import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { postLookupDetails, postFlagDetails } from "../../Actions/lookupAPI";
import { postFlagAttachment } from "../../Actions/CommonAPI";
import axios from "axios";
import API from "../../helpers/api";
import swal from "sweetalert";

class LookupAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleName: "",
      lookupinfo: {
        Interval: "",
        Category: "",
        /* Class: "", */
        TypeofShip: "",
        TypeofPort: "",
        Unit:"",
        Zone:"",
        EquipmentType: "",
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.AddLookup = this.AddLookup.bind(this);
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
      // this.props.history.goBack();
    };
  }
  componentDidMount() {
    const { match } = this.props;
    const { params } = match;
    const { type } = params;
    console.log("titleName", type);
    this.setState({ titleName: type });
  }
 /*  static getDerivedStateFromProps(nextProps, prevState) {
    const { LookupValue } = nextProps;
    if (LookupValue !== true) {
      prevState.lookupinfo.TypeofPort = "";
      }
    } */

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "Interval") {
      var pattern = /^[0-9]*\.?[0-9]*$/;
      if (pattern.test(e.target.value)) {
      const phone = e.target.validity.valid
        ? e.target.value
        : this.state.lookupinfo.Interval;
      this.state.lookupinfo[nodeName] = phone;
      this.setState({});
      }
    } else {
      this.state.lookupinfo[nodeName] = e.target.value;
      this.setState({});
    }
  }

  AddLookup() {
    let currentuser = JSON.parse(localStorage.getItem("currentUser"));
    const { match, dispatch,t } = this.props;
    const { params } = match;
    const { type } = params;
    const {
     /*  Class, */
      Category,
      Interval,
      TypeofShip,
      TypeofPort,
      Unit,
      Zone,
      EquipmentType,
    } = this.state.lookupinfo;
    if(Interval !=="" ||Category !=="" /* ||Class !=="" */||EquipmentType !== ""||TypeofShip !== "" ||Unit !== ""||Zone !== ""/* ||TypeofPort!=="" */){
    let lookup = {
      lookUpToAdd: type === "Interval" ? "intervals" : "lookup",
      lookUpType:
        type === "Interval"
          ? "intervals"
          : type === "Category"
            ? "category"
            /* : type === "Class"
              ? "class" */
              : type === "TypeofShip"
                ? "typeofship"
                : type === "Unit"
                ? "unit"
                : type === "Zone"
                ? "zone"
                /* :type === "TypeofPort"
                ? "typeofport" */
                 :"equipmentType",
      lookUpValue:
        type === "Interval"
          ? Interval
          : type === "Category"
            ? Category
           /*  : type === "Class"
              ? Class */
              : type === "TypeofShip"
                ? TypeofShip
                : type === "Unit"
                ? Unit
                : type === "Zone"
                ? Zone
               /*  :type === "TypeofPort"
                ? TypeofPort */
                : EquipmentType,    
      createdBy: currentuser.name,
      intervalYear: type === "Interval" ? Interval : 0,
    };
    let url1="";
    if(lookup.lookUpType==="intervals"){
      var decimals = lookup.intervalYear- Math.floor(lookup.intervalYear);
       console.log(decimals);
       if(decimals===0){
         lookup.intervalYear=Math.round(lookup.intervalYear);
         lookup.lookUpValue=Math.round(lookup.lookUpValue);;
       }
     url1=`${API.lookupIntervalExist}?num=${lookup.lookUpValue}`;
    }else{
    url1=`${API.lookupExist}?LookupType=${lookup.lookUpType}&LookupValue=${lookup.lookUpValue}`;
    }
      axios.get(url1).then((response) => {
        console.log(response.data,'datacheck')
        if(response.data === true){
    dispatch(postLookupDetails(lookup, type,t));
    this.hideSidePanel();
        }
        else if(response.data===false){
          swal(
            "Error!",
            `${type==="TypeofShip"? "Ship type":`${type}`} already exist. Please change the 
            ${lookup.lookUpType==="typeofship"? "ship type":`${lookup.lookUpType}`}.`,
            "warning"
          );
          lookup.lookUpValue=""
        }
        dispatch({
          type: "getLookupExistListSuccess",
          data: response.data,
        });
        
      })
  .catch((error) => {
 dispatch({
      type: "getLookupExistListFailure",
      data: "error",
    });
  }); 
  }
}
  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  };

  render() {
    const { showSidePane, arraylist,t } = this.props;
    const { titleName } = this.state;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3">
          <div className="w-100">
            <div className="panel-box search-filter-box">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
                style={{display:'inline-flex',alignItems:'center'}}
              >
               <span style={{marginTop:'-1px'}}>&larr;</span>{t("CommonText.Return")}
              </button>
              <div
                className="card MM-card-header mt-2 mb-0"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                   {t("ShipManagementContent.Add")}{" "}
                    {titleName === "EquipmentType" ? `${t("EquipmentTypeScreen.Title")}`
                      : titleName === "TypeofShip" ? `${t("TypeofShipScreen.Title")}`:titleName === "Interval"?`${t("IntervelScreen.Title")}`:titleName === "Category"?`${t("CategoryScreen.Title")}`:
                      titleName === "Unit"?`${t("UnitScreen.Title")}`:titleName === "Zone"?`${t("ZoneScreen.Title")}` /* : titleName === "TypeofPort" ? "Type of Port" */:titleName}
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  {titleName === "Interval" ? (
                    <div className={"col-lg-6 "}>
                      <label className="form-label">{t("IntervelScreen.Title")}</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                       /*  pattern="[0-9]*" */
                        value={this.state.lookupinfo.Interval}
                        placeholder={t("IntervelScreen.Title")}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null}
                  {titleName === "Category" ? (
                    <div className={"col-lg-6 "}>
                      <label className="form-label">{t("CategoryScreen.Title")}</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                        value={this.state.lookupinfo.Category}
                        placeholder={t("CategoryScreen.Title")}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null}
                 {/*  {titleName === "Class" ? (
                    <div className={"col-lg-6"}>
                      <label className="form-label">Class</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                        value={this.state.lookupinfo.Class}
                        placeholder=""
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null} */}
                  {titleName === "TypeofShip" ? (
                    <div className={"col-lg-6"}>
                      <label className="form-label">{t("TypeofShipScreen.Title")}</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                        value={this.state.lookupinfo.TypeofShip}
                        placeholder={t("TypeofShipScreen.Title")}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null}
                  {/*  {titleName === "TypeofPort" ? (
                    <div className={"col-lg-6"}>
                      <label className="form-label">Type</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                        value={this.state.lookupinfo.TypeofPort}
                        placeholder=""
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null} */}
                  {titleName === "EquipmentType" ? (
                    <div className={"col-lg-6"}>
                      <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                        value={this.state.lookupinfo.EquipmentType}
                        placeholder={t("EquipmentTypeScreen.Title")}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null}
                   {titleName === "Unit" ? (
                    <div className={"col-lg-6 "}>
                      <label className="form-label">{t("UnitScreen.Title")}</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                        value={this.state.lookupinfo.Unit}
                        placeholder={t("UnitScreen.Title")}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null}
                   {titleName === "Zone" ? (
                    <div className={"col-lg-6 "}>
                      <label className="form-label">{t("ZoneScreen.Title")}</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name={this.state.titleName}
                        value={this.state.lookupinfo.Zone}
                        placeholder={t("ZoneScreen.Title")}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                  ) : null}
                  <div className={"col-lg-6"}>
                    <br></br>
                    <div
                      className="search-btn-col pt-3"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.AddLookup()}
                      >
                        {" "}
                        {t("ShipManagementContent.Add")}{" "}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.hideSidePanel()}
                      >
                        {" "}
                       {t("ComplianceandBudgetScreen.Cancel")}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    FlagAttachment: state.lookupReducer.FlagAttachment,
    /* LookupValue:state.lookupReducer.LookupValue||true, */
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(LookupAdd));